import React from 'react'
import { CardGiftcard } from '@mui/icons-material'
import AddBusinessIcon from '@mui/icons-material/AddBusiness'
import CancelIcon from '@mui/icons-material/Cancel'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
// ICONS
import CompassCalibrationIcon from '@mui/icons-material/CompassCalibration'
import DeleteIcon from '@mui/icons-material/Delete'
// TO DO: remove when not needed
import EditIcon from '@mui/icons-material/Edit'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import SimCardIcon from '@mui/icons-material/SimCard'
// MUI components
import { Box, Divider } from '@mui/material'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Menu from '@mui/material/Menu'
import { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { alpha, styled } from '@mui/material/styles'
import FaberFeatureToggle from 'common/FaberComponents/FaberFeatureToggle'
import useOrbitFlag from 'hooks/useOrbitFlag'

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}))

export default function ActionMenuForOneUser({
  productType,
  handleSuspendOrUnsuspendDialogOpen,
  handleAssignVoucherDialogOpen,
  handleWinbackDialogOpen,
  handleCancelSubDialogOpen,
  handleRefreshNetworkDialogOpen,
  handleUserEditDetailsDialogOpen,
  showRefreshNetworkButton,
  handleReprovisionEsim,
  handleSwitchWhitelistDialogOpen,
  handleDeletePaymentMethodDialogOpen,
  hasPendingDeletionRequest,
  handleUndoDeleteRequest,
  handleCreateDeleteRequest,
  EsimAllocateByWhitelistIDDialogOpen
}: ActionProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const editUserDetailsFlag = useOrbitFlag('editUserDetails')

  const handleClose = () => {
    setAnchorEl(null)
  }

  const isOtp: boolean = productType === 'otp'

  return (
    <>
      <Box>
        <Button
          variant='contained'
          id='fade-button'
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ fontSize: '12px', padding: '4px 12px' }}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>
        <StyledMenu
          id='fade-menu'
          MenuListProps={{
            'aria-labelledby': 'fade-button'
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {showRefreshNetworkButton && (
            <FaberFeatureToggle
              activeComponent={
                <MenuItem
                  sx={{ fontSize: '12px' }}
                  onClick={handleRefreshNetworkDialogOpen}
                >
                  <CloudSyncIcon />
                  Refresh network
                </MenuItem>
              }
              inactiveComponent={<></>}
              feature='refresh-network'
            />
          )}
          {isOtp && (
            <MenuItem
              onClick={() => {
                handleSwitchWhitelistDialogOpen &&
                  handleSwitchWhitelistDialogOpen()
              }}
              sx={{ fontSize: '12px' }}
            >
              <CompassCalibrationIcon />
              Switch whitelist
            </MenuItem>
          )}

          {isOtp && editUserDetailsFlag && (
            <MenuItem
              onClick={() => handleUserEditDetailsDialogOpen()}
              sx={{ fontSize: '12px' }}
            >
              <EditIcon />
              Edit User Details
            </MenuItem>
          )}

          {handleReprovisionEsim && (
            <MenuItem
              onClick={() => {
                handleReprovisionEsim()
              }}
              sx={{ fontSize: '12px' }}
            >
              <SimCardIcon />
              Reprovision esim
            </MenuItem>
          )}

          <MenuItem
            onClick={() => handleAssignVoucherDialogOpen()}
            sx={{ fontSize: '12px' }}
          >
            <CardGiftcard />
            Assign voucher
          </MenuItem>

          {isOtp && (
            <MenuItem
              onClick={() => handleWinbackDialogOpen()}
              sx={{ fontSize: '12px' }}
            >
              <AddBusinessIcon />
              Customer winback
            </MenuItem>
          )}

          <MenuItem
            onClick={() => EsimAllocateByWhitelistIDDialogOpen()}
            sx={{ fontSize: '12px' }}
          >
            <SimCardIcon />
            Sim allocate by whitelist
          </MenuItem>

          <Divider sx={{ width: '100%' }} />

          {!isOtp && (
            <>
              <MenuItem
                sx={{ fontSize: '12px' }}
                onClick={handleSuspendOrUnsuspendDialogOpen}
              >
                <PersonRemoveIcon />
                Suspend/Unsuspend User
              </MenuItem>

              <MenuItem
                sx={{ fontSize: '12px' }}
                onClick={handleCancelSubDialogOpen}
              >
                <CancelIcon />
                Cancel Subscription Now
              </MenuItem>
            </>
          )}

          {/* Delete user's payment method from stripe */}
          {isOtp && (
            <MenuItem
              sx={{ fontSize: '12px' }}
              onClick={handleDeletePaymentMethodDialogOpen}
            >
              <DeleteIcon />
              Delete payment method
            </MenuItem>
          )}

          {hasPendingDeletionRequest ? (
            <MenuItem
              sx={{ fontSize: '12px' }}
              onClick={handleUndoDeleteRequest}
            >
              <DeleteIcon />
              Undo Delete Request
            </MenuItem>
          ) : (
            <MenuItem
              sx={{ fontSize: '12px' }}
              onClick={handleCreateDeleteRequest}
            >
              <DeleteIcon />
              Create Delete Request
            </MenuItem>
          )}
        </StyledMenu>
      </Box>
    </>
  )
}

interface ActionProps {
  handleEsimRequestDialogOpen: (event: string) => void
  handleEsimRequestDialogV2Open: () => void
  handleSuspendOrUnsuspendDialogOpen: () => void
  handleUserPlanDialogOpen: () => void
  handleUndoDeleteRequest?: () => void
  handleUserEditDetailsDialogOpen: () => void
  handleAssignVoucherDialogOpen: () => void
  handleWinbackDialogOpen: () => void
  handleCancelSubDialogOpen: () => void
  handleRefreshNetworkDialogOpen: () => void
  showRefreshNetworkButton: boolean
  hasPendingDeletionRequest?: boolean
  productType?: string
  userId?: string
  handleSwitchWhitelistDialogOpen?: () => void
  handleDeletePaymentMethodDialogOpen: () => void
  handleReprovisionEsim?: () => void
  handleCreateDeleteRequest?: () => void
  EsimAllocateByWhitelistIDDialogOpen: ()=>void
}
